import React, { FC } from 'react';
import styled from '@emotion/styled';
import { SERVICE_TYPE } from '~../__queries__/globalTypes';
import Heading from '~ComponentsImproved/Typography/Heading';
import { useI18n } from '~Hooks';
import { useCart } from '~Components/CartProvider';

const ServiceTypeBar = styled.div<{ isParkedOrder?: boolean }>`
  border-top: 1px solid var(--colorBlueGray1100);
  display: flex;
  align-items: center;
  justify-content: space-between;
  opacity: ${({ isParkedOrder }) => (isParkedOrder ? 0.6 : 1)};
`;

const ServiceType = styled.div<{
  selected?: boolean;
}>`
  flex: 1px;
  padding: 12px;
  height: 56px;
  border-left: 4px solid transparent;
  border-color: ${({ selected }) => (selected ? 'var(--colorUIYellow)' : 'transparent')};
  background-color: ${({ selected }) =>
    selected ? 'var(--colorBlueGray1300)' : 'var(--colorBlueGray1200)'};
  display: flex;
  flex-flow: column nowrap;
  justify-content: center;
  box-sizing: border-box;
`;

interface Props {
  /** If this prop is set, we disable all actions and just use this component as a visual element */
  parkedOrderServiceType?: SERVICE_TYPE;
}

/**
 * Component responsible for changing service type in QSR
 * @params parkedOrderServiceType - If this prop is set, we disable all actions and just use this component as a visual element
 */
const ServiceTypeChanger: FC<Props> = ({ parkedOrderServiceType }) => {
  const { i18n } = useI18n();

  const cart = useCart();

  const serviceType = parkedOrderServiceType ? parkedOrderServiceType : cart.serviceType;

  return (
    <ServiceTypeBar isParkedOrder={Boolean(parkedOrderServiceType)}>
      <ServiceType
        onTouchStart={() => cart.updateServiceType(SERVICE_TYPE.TAKE_AWAY)}
        selected={serviceType === 'TAKE_AWAY'}>
        <Heading
          level={4}
          color={serviceType === 'TAKE_AWAY' ? 'white' : 'var(--colorBlueGray400)'}>
          {i18n('POS.TakeAway')}
        </Heading>
      </ServiceType>
      <ServiceType
        onTouchStart={() => cart.updateServiceType(SERVICE_TYPE.EAT_HERE)}
        selected={serviceType === 'EAT_HERE'}>
        <Heading
          level={4}
          color={serviceType === 'EAT_HERE' ? 'white' : 'var(--colorBlueGray400)'}>
          {i18n('POS.Eathere')}
        </Heading>
      </ServiceType>
    </ServiceTypeBar>
  );
};

export default React.memo(ServiceTypeChanger);
